export default function Tagline() {
  return (
    <section
      data-testid="tagline-section"
      className="relative bg-ivory py-32 md:py-44 lg:py-56 px-6 md:px-12 lg:px-20"
    >
      <div className="mx-auto max-w-[1100px] text-center reveal">
        <div className="ink-divider mx-auto mb-12" />
        <h2
          data-testid="hero-tagline"
          className="font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.25] tracking-tight"
        >
          Beyond the familiar, beyond the routine,
          <br />
          <em className="italic text-teal">lies A Wider Horizon.</em>
        </h2>
        <div className="ink-divider mx-auto mt-12" />
      </div>
    </section>
  );
}
